import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from '../pmi-select';
import { PmiFormControl } from '../pmi-select/pmi-form-control';

const list = Object.freeze([
  {
    id: 'D',
    value: 'Destro',
  },
  {
    id: 'S',
    value: 'Sinistro',
  },
]);

interface ListDxSxProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  expatriationBan?: boolean;
  error?: boolean;
  label: string;
}

const ListDxSxComponent = ({
  disabled,
  onChange,
  required,
  value,
  error,
  expatriationBan,
  label,
}: ListDxSxProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`label-${label}`}>
        {required ? `${label} *` : label || undefined}
      </InputLabel>
      <PmiSelect
        labelId={`label-${label}`}
        id={`id-${label}`}
        name={`id-${label}`}
        value={value}
        label={required ? `${label} *` : label || undefined}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {list
          .filter((item) => (expatriationBan ? item.id === '0' : true))
          .map((item: ItemVM) => (
            <MenuItem key={item.id} value={item.id}>
              {item.value}
            </MenuItem>
          ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListDxSxComponent.displayName = 'List dx or sx component';

const ListDxSx = memo(ListDxSxComponent);

export default ListDxSx as typeof ListDxSxComponent;
